import { render, staticRenderFns } from "./createPriceLabel.vue?vue&type=template&id=4363c794&scoped=true"
import script from "./createPriceLabel.vue?vue&type=script&lang=js"
export * from "./createPriceLabel.vue?vue&type=script&lang=js"
import style0 from "./createPriceLabel.vue?vue&type=style&index=0&id=4363c794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4363c794",
  null
  
)

export default component.exports